import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import PropTypes, { bool } from 'prop-types';
import axios from '../../axios';

const NewUserModal = ({ newUser,setNewUser }) => {
    const [data, setData] = useState({name:"",email:"",password:"",password_confirmation:"",sucursales:[],rol:"",employee_id:null});
    const [validate,setValidate] = useState({name:true, email:true, password:true,sucursales:true,rol:true});
    const [roles,setRoles] = useState([]);
    
     useEffect(() => {   
          //geting all roles
          axios.get('api/roles').then((res)=>{
            setRoles(res.data)
            M.FormSelect.init(document.querySelector('#select-rol'));
        }).catch(e=>console.log("error ",e));
    }, []);

    useEffect(()=>{ 
        if(newUser.id){    
            setData({...data,name: newUser.nombre + " " + newUser.apellidos,sucursales:[newUser.sucursal_id],employee_id:newUser.id});
        }
    },[newUser]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if(data.password !== data.password_confirmation) return M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Las contraseñas no coinciden</span>',classes:"error-notify"});
        axios.post('api/newuser',data)
        .then(res=>{
            M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>usuario creado exitosamente</span>',classes:"success-notify"})
            setTimeout(() => {
              closeModal()
            }, 3000);
        }).catch(e=>{
            console.log("error",e)
            if(e.message) M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>'+e.message+'</span>',classes:"error-notify"})
            if(e.response?.data?.errors){
                let errors = e.response.data.errors;
                setValidate({
                    name:(errors.name)? false:true,
                    email:(errors.email)? false:true,
                    password:(errors.password)? false:true,
                    password_confirmation:(errors.password_confirmation)? false:true,
                    sucursal_id:(errors.sucursal_id)? false:true,
                    rol:(errors.rol)? false:true
                });
            }
        });
    };

    const closeModal = () =>{
        //resetea los valores de data
        setNewUser({});
        setData({name:"",email:"",password:"",password_confirmation:"",sucursales:[],rol:""});
        setValidate({name:true, email:true, password:true, sucursales:true, rol:true});
        document.querySelector('#general-form input[type="checkbox"]').checked = false;
        document.querySelector('#general-form select').selectedIndex = 0;

        let instance = M.Modal.getInstance(document.querySelector('#new-user-modal'));
        instance.close();
    }

    const _handleCheck = (e) =>{ 
        let value = e.target.checked;
        if(value){
          setData({...data,email: newUser.email});
        }else{
          setData({...data,email: ""});
        }
    }

    const _createRandomPassword = () =>{
        let length = 12,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            password = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
            password += charset.charAt(Math.floor(Math.random() * n));
        }
        console.log(password);
        setData({...data,password:password,password_confirmation:password});
    }

    return (
        <div id="new-user-modal" className="modal">
            <div className="modal-content">
                <div className='close-btn' onClick={closeModal}>
                    <i className="material-icons">close</i>
                </div>
                <h5>Crear Usuario del sistema</h5>
                <form onSubmit={handleSubmit} id='general-form'>
                    <div className="row">
                        <div className="input-text col s12">
                            <label htmlFor="name">Nombre</label>
                            <input type="text" id="name" value={data.name} readOnly/>
                        </div>
                
                        <div className='row'>
                            <div className="input-text col s12 m8">
                                <label htmlFor="email" className="active">Correo Electrónico</label>
                                <input type="email" id="email" value={data.email} onChange={(e)=>setData({...data,email:e.target.value})}/>
                                {!validate.email &&  <span className="helper-text t-rojo">El email es obligatorio.</span>}
                            </div>
                            <div className="col s12 m4 centrado">
                                <div style={{marginTop:"20px!important"}}>
                                    <label>
                                        <input type="checkbox" className="filled-in" onChange={(e)=>_handleCheck(e)} />
                                        <span>Usar correo registrado</span>
                                    </label> 
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-text col s12 m8">
                                <label htmlFor="password">Contraseña</label>
                                <input type="password" id="password" required value={data.password} onChange={(e)=>setData({...data,password:e.target.value})}/>
                                {!validate.password &&  <span className="helper-text t-rojo">El password es obligatorio.</span>}
                            </div>
                            <div className="input-text col s12 m4">
                                <button className="btn" type="button" onClick={_createRandomPassword}>Generar password</button>
                                {data.password.length > 0 && 
                                <>  
                                  <button className="btn badge-success" type="button" onClick={() => navigator.clipboard.writeText(data.password)}>
                                    <i className="material-icons">content_copy</i>
                                    </button>
                                    <span className="helper-text">Click para copiar</span>
                                    
                                </>
                                }
                               
                            </div>
                        </div>
                        <div className="input-text col s12 m4">
                                <label htmlFor="password_confirmation">Confirmar Contraseña</label>
                                <input type="password" id="password_confirmation" required value={data.password_confirmation} onChange={(e)=>setData({...data,password_confirmation:e.target.value})}/>
                                {!validate.password_confirmation &&  <span className="helper-text t-rojo">La confirmación del password es obligatoria.</span>}
                        </div>

                        <div className="input-text col s12 m6">
                            <div className="input-text">
                            <label htmlFor="puesto">Rol *</label>
                                <select className='browser-default' onChange={(e)=>setData({...data,rol:e.target.value})}>
                                    <option defaultValue="seleccionar" disabled>Seleccione un rol de usuario</option>
                                    {roles.map((item,i)=>
                                        <option value={item.name}  key={item.id}>{item.name}</option>
                                    )}
                                </select>
                                {!validate.rol &&  <span className="helper-text t-rojo">El rol es obligatorio.</span>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12">
                            <button type="submit" className="btn right">Crear Usuario</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

NewUserModal.propTypes = {
    email: PropTypes.string.isRequired,
};

export default NewUserModal;